/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Nutrition_Consultation_TermsInputs */

const en_service_type_nutrition_consultation_terms = /** @type {(inputs: Service_Type_Nutrition_Consultation_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dietitian, nutritionist, diet advice, follow up visit, diet`)
};

const pl_service_type_nutrition_consultation_terms = /** @type {(inputs: Service_Type_Nutrition_Consultation_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dietetyk, dietetyczka, wizyta u dietetyka, porada dietetyczna, kontrolna wizyta, dieta`)
};

/**
* | output |
* | --- |
* | "dietitian, nutritionist, diet advice, follow up visit, diet" |
*
* @param {Service_Type_Nutrition_Consultation_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_nutrition_consultation_terms = /** @type {((inputs?: Service_Type_Nutrition_Consultation_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Nutrition_Consultation_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_nutrition_consultation_terms(inputs)
	return en_service_type_nutrition_consultation_terms(inputs)
});